<template>
  <div class="p-6 bg-gray-200 min-h-screen flex justify-center items-center">
    <div class="w-full max-w-md">
      <form class="mt-8 bg-white shadow-xl overflow-hidden" @submit.prevent="submit">
        <div class="px-10 py-12">
          <div class="flex justify-center">
              <img class="w-2/3 object-contain" alt="AWA - 1-2-3.tv" title="AWA - 1-2-3.tv" :src="logoUrl"/>
          </div>
          <text-input v-model="form.email" :errors="$page.props.errors.email" class="mt-10" :label="$t('pages.auth.login.email')" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" class="mt-6" :label="$t('pages.auth.login.password')" type="password" />
          <label class="mt-6 select-none flex items-center" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox">
            <span class="text-sm">{{$t('pages.auth.login.stay_logged_in')}}</span>
          </label>
        </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-200 flex justify-end items-center">
          <loading-button :loading="sending" class="px-3 py-2 bg-ezdBlue rounded text-white" type="submit">{{$t('pages.auth.login.login')}}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'

export default {
    metaInfo: {title: 'Login'},
    components: {
        LoadingButton,
        Logo,
        TextInput,
    },
    props: {
        errors: Object,
    },
    data() {
        return {
            sending: false,
            form: {
                email: '',
                password: '',
                remember: null,
            },
        }
    },
    methods: {
        submit() {
            this.sending = true;
            this.$inertia.post(this.route('login.attempt'), {
                    email: this.form.email,
                    password: this.form.password,
                    remember: this.form.remember,
                },
                {
                    onFinish: () => {
                        this.sending = false;
                    },
                    onSuccess: () => {}
                });
        }
    },
    computed: {
        logoUrl() {
            return require('../../../img/' + this.$page.props.tenant.frontend.logo_file);
        }
    }
}
</script>
